import React from 'react';
import { PromoSuppSettlementDto } from '../api/promoSuppSettlementApi';
import { formatDateToISO } from '@/shared/utils/dateUtils';

interface SettlementSectionProps {
    settlementStartDate: string;
    settlementEndDate: string;
    settlements: PromoSuppSettlementDto[];
    settlementsLoading: boolean;
    onStartDateChange: (v: string) => void;
    onEndDateChange: (v: string) => void;
    onFetchSettlements: () => Promise<void>;
    onForceProcess: (s: PromoSuppSettlementDto) => Promise<void>;
    onSwOnly: (s: PromoSuppSettlementDto) => Promise<void>;
}

const SettlementSection: React.FC<SettlementSectionProps> = ({
                                                                 settlementStartDate,
                                                                 settlementEndDate,
                                                                 settlements,
                                                                 settlementsLoading,
                                                                 onStartDateChange,
                                                                 onEndDateChange,
                                                                 onFetchSettlements,
                                                                 onForceProcess,
                                                                 onSwOnly,
                                                             }) => (
    <div className="filter-section mission-list-section">
        <div className="mission-list-header">
            <span className="mission-section-title">프로모션 보류 현황 관리</span>
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
            <input
                type="date"
                className="mission-input"
                style={{ width: 140 }}
                value={settlementStartDate}
                onChange={(e) => onStartDateChange(e.target.value)}
            />
            <span>~</span>
            <input
                type="date"
                className="mission-input"
                style={{ width: 140 }}
                value={settlementEndDate}
                onChange={(e) => onEndDateChange(e.target.value)}
            />
            <button
                type="button"
                className="mission-btn mission-btn-primary"
                style={{ padding: '6px 16px' }}
                onClick={onFetchSettlements}
                disabled={settlementsLoading}
            >
                {settlementsLoading ? '조회 중...' : '조회'}
            </button>
        </div>

        {settlements.length === 0 ? (
            <div className="mission-empty">
                <i className="fas fa-check-circle" />
                <p>기간을 선택 후 조회하거나, 처리 대기 중인 항목이 없습니다.</p>
            </div>
        ) : (
            <div className="table-container">
                <table className="supplier-selection-table">
                    <thead>
                    <tr>
                        <th>협력사 ID</th>
                        <th>정산 기간</th>
                        <th>프로모션 비용</th>
                        <th>주정산 비용</th>
                        <th>부족금액</th>
                        <th>상태</th>
                        <th>처리</th>
                    </tr>
                    </thead>
                    <tbody>
                    {settlements.map((s) => {
                        const partnerAmt = s.partnerAcctVal ?? 0;
                        const shortfall = s.totalPromoCost - partnerAmt;
                        return (
                            <tr key={s.seqNo}>
                                <td>{s.suppId}</td>
                                <td>
                                    {formatDateToISO(s.acctStDate)} ~{' '}
                                    {formatDateToISO(s.acctEdDate)}
                                </td>
                                <td>{s.totalPromoCost.toLocaleString('ko-KR')}원</td>
                                <td>{partnerAmt.toLocaleString('ko-KR')}원</td>
                                <td style={{ color: '#e53e3e', fontWeight: 600 }}>
                                    {shortfall.toLocaleString('ko-KR')}원
                                </td>
                                <td>
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                padding: '2px 8px',
                                                borderRadius: 4,
                                                fontSize: '0.8rem',
                                                fontWeight: 600,
                                                background: '#fed7d7',
                                                color: '#c53030',
                                            }}
                                        >
                                            입금대기
                                        </span>
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                    <div className="mission-table-actions">
                                        <button
                                            type="button"
                                            className="mission-action-btn mission-action-delete"
                                            onClick={() => onForceProcess(s)}
                                        >
                                            강제진행
                                        </button>
                                        <button
                                            type="button"
                                            className="mission-action-btn mission-action-activate"
                                            onClick={() => onSwOnly(s)}
                                        >
                                            주정산만 진행
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        )}
    </div>
);

export default SettlementSection;
